import './slick.css';
import './slick-theme.css';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Box from '@mui/material/Box';
import React, { useRef } from 'react';
import SlickSlider from 'react-slick';

import { petrol, yellow } from '../../styles/mui/colors';

const SampleNextArrow = ({ className, style, onClick }) => {
  
  return (
    <Box className={className} onClick={onClick} sx={{ ...style, display: 'block' }}>
      <ArrowForwardIosIcon />
    </Box>
  );
};

const SamplePrevArrow = ({ className, style, onClick }) => {
  
  return (
    <Box
      className={className}
      onClick={onClick}
      sx={{ ...style, display: 'block', background: 'green' }}
    >
      <ArrowBackIosIcon />
    </Box>
  );
};

const Swiper = ({ children, ...rest }) => {
  const clickableRef = useRef(true);
  const sliderRef = useRef(null);
  const handleClick = (event) => {
    if (!clickableRef.current) {
      event.stopPropagation();
      event.preventDefault();
    }
    clickableRef.current = true;
  };
  const swipeEvent = () => {
    if (sliderRef?.current?.innerSlider?.list) {
      sliderRef.current.innerSlider.list.onclick = handleClick;
      clickableRef.current = false;
    }
  };

  return (
    <Box
      sx={{
        '.slick-active div.dot': {
          backgroundColor: yellow.main,
        },
        '.slick-arrow': {
          color: petrol.main,
          background: 'unset',
        },
        '.slick-arrow:before': {
          content: '""',
        },
        '.slick-arrow:hover': {
          color: yellow.main,
        },
      }}
    >
      <SlickSlider
        customPaging={(i) => (
          <Box
            key={i}
            sx={{
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box
              className="dot"
              sx={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                border: '2px solid',
                borderColor: yellow.main,
              }}
            />
          </Box>
        )}
        easing="ease"
        nextArrow={<SampleNextArrow />}
        prevArrow={<SamplePrevArrow />}
        ref={sliderRef}
        responsive={[
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ]}
        speed={1000}
        swipeEvent={swipeEvent}
        swipeToSlide={true}
        {...rest}
      >
        {children}
      </SlickSlider>
    </Box>
  );
};

export default Swiper;
